import { useState } from "react";
import { useModalControl } from "../../customHooks/useModalControl";
import { CertificateStatus } from "../../redux/features/auth/auth.type";
import { Icon } from "../icons/icon";
import { ImageViewModal } from "../modals/app_modals/imageViewModal";

export const UploadedFileView = ({
  viewLink = "",
  text = "View document",
  className = "",
  iconClassName = "",
  textClassName = "",
  variant = "normal",
  status,
}: {
  viewLink?: string;
  text?: string;
  className?: string;
  iconClassName?: string;
  textClassName?: string;
  variant?: "normal" | "mini";
  status?: CertificateStatus;
}) => {
  const [link, setLink] = useState<string>("");

  const { modal, modalOpen, handleModalClose, handleModalOpen } =
    useModalControl();

  const getColor = () => {
    switch (status) {
      case "active":
        return "!text-pry-green-200";
      case "pending":
        return "!text-gold-200";
      case "submitted":
        return "!text-pry-green-200";
      case "approved":
        return "!text-pry-green-200";
      case "rejected":
        return "!text-error-200";
      default:
        return "!text-pry-green-200";
    }
  };

  return (
    <>
      <div
        className={`
        !w-fit flex items-center
        gap-3
        ${variant === "mini" && "!gap-[6px]"}
        ${className}
        `}
      >
        <div
          className={`
          w-fit rounded-full p-2
          bg-light-green-bg ${iconClassName} ${
            variant === "mini" && "!p-0 !bg-none"
          } ${getColor()}
          `}
        >
          <Icon
            svg="small-document-icon"
            width={16}
            height={16}
            className={`w-fit`}
          />
        </div>

        <button
          type="button"
          className={`!font-medium ${textClassName} ${
            variant === "mini" && "!text-sm"
          } ${getColor()}`}
          onClick={() => {
            setLink(viewLink);
            handleModalOpen("viewImageModal");
          }}
        >
          {text}
        </button>
      </div>

      <ImageViewModal
        modalOpen={modalOpen && modal === "viewImageModal"}
        onModalClose={() => {
          handleModalClose();
        }}
        src={link}
      />
    </>
  );
};
